//
// Study-Programs
//

export const initStudyProgramList = () => {
    const studyFinderResultList = document.querySelector('.study-finder .result__list');

    if (!studyFinderResultList) {
        return;
    }

    const items = [...studyFinderResultList.children],
          cardHeaders = items.map(item => item.querySelector('.card__header'));

    const equalizeCardHeaderHeight = () => {
        // Reset heights to auto to get natural heights
        cardHeaders.forEach(header => {
            if (header) header.style.height = 'auto';
        });

        // Find the maximum height
        const maxHeight = Math.max(...cardHeaders.map(header =>
            header ? header.offsetHeight : 0
        ));

        // Set all headers to the maximum height
        cardHeaders.forEach(header => {
            if (header) header.style.height = `${maxHeight}px`;
        });
    }

    const resizeObserver = new ResizeObserver(equalizeCardHeaderHeight);

    // Observe each header element
    cardHeaders.forEach(header => {
        if (header) resizeObserver.observe(header);
    });

    equalizeCardHeaderHeight(); // Initial check
    window.addEventListener('resize', equalizeCardHeaderHeight); // Check on resize Window
}